module.exports = __webpack_public_path__ + "img/CARLOS.593cb041.jpeg";